import { List } from 'foundations-components/transitional/components/List';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const QuestionTitle = styled.span.withConfig({
  displayName: "QuestionAnswerList__QuestionTitle"
})(["font-weight:500;"]);
export const QuestionAnswerList = ({
  answers,
  disabled = false,
  multipleSelection,
  selectedAnswerIds,
  onSelectAnswer
}) => {
  return /*#__PURE__*/_jsx(List, {
    childStyles: {
      marginBlockEnd: '200'
    },
    "data-test-id": "question-answer-list",
    wrapChildren: true,
    children: answers.map(answer => /*#__PURE__*/_jsx(SelectableButton, {
      block: true,
      "data-test-id": "quiz-radio-option",
      disabled: disabled,
      name: "quiz-options",
      onClick: () => onSelectAnswer(answer.id),
      selected: selectedAnswerIds.includes(answer.id),
      title: /*#__PURE__*/_jsx(QuestionTitle, {
        children: answer.text
      }),
      truncatable: false,
      type: multipleSelection ? 'checkbox' : 'radio'
    }, answer.id))
  });
};